import { render, staticRenderFns } from "./CCTitle.vue?vue&type=template&id=74ffb84b&scoped=true&"
import script from "./CCTitle.vue?vue&type=script&lang=ts&"
export * from "./CCTitle.vue?vue&type=script&lang=ts&"
import style0 from "./CCTitle.vue?vue&type=style&index=0&id=74ffb84b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ffb84b",
  null
  
)

export default component.exports